let config = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "forwood-saas-testing-forwoodid",
    BATCH_PROCESS_BUCKET_NAME: "forwood-saas-testing-forwoodid-batch-user-process",
  },
  appSyncAPI: {
    REGION: "us-west-2",
    URL: "https://mlx75vzwgvh5jfw6os57rnjl7e.appsync-api.us-west-2.amazonaws.com/graphql",
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://egtd0c5ryg.execute-api.us-west-2.amazonaws.com/env",
    USER_TOKEN_URL: "https://byuxoxeeb7.execute-api.us-west-2.amazonaws.com/prod",
  },
  configurationService: {
    URL: "https://config.testing.saas.forwoodsafety.com",
    WEBSOCKET: "wss://rs4k9t9nml.execute-api.us-west-2.amazonaws.com/testing",
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_IN4qXIpGt",
    IDENTITY_POOL_ID: "us-west-2:fc621667-40d7-4bf5-b141-519a578d12af",
    USERPOOL_HOSTED_DOMAIN: "forwood-saas-id-testing",
    USERPOOL_ADFS_CALLBACK_URL: "https://id.testing.saas.forwoodsafety.com",
    USERPOOL_ADFS_LOGOUT_URL: "https://id.testing.saas.forwoodsafety.com",
    AUTHENTICATED_ROLE_ARN: "arn:aws:iam::162551973374:role/testing-CA",
  },
  samlProvider: {
    NAME: "",
    SUPPORTED_LIST: "forwood",
  },
  reactApp: {
    VERSION: "1.42.6",
    HOSTNAME: "id.testing.saas.forwoodsafety.com",
    ENV_NAME: "testing",
    COOKIE_DOMAIN: ".testing.saas.forwoodsafety.com",
    SECURE_PROTOCOL: true,
    FORWOOD_COMPANY_ID: "a542ae2b-6931-4307-8ad6-ae03c182c6ca",
    FORWOOD_HOMEPAGE_MICROFRONTEND_URL: "https://homepage.testing.saas.forwoodsafety.com",
  },
  USERPOOL_ADFS_LAUNCH_URL(clientId) {
    return 'https://'+this.cognito.USERPOOL_HOSTED_DOMAIN+'.auth.'+this.cognito.REGION+'.amazoncognito.com/authorize?redirect_uri='+this.cognito.USERPOOL_ADFS_CALLBACK_URL+'&response_type=code&client_id='+clientId;
  },
};

export default config;
